import { motion } from "framer-motion";
import { MaskedLine } from "./Reveal";

export default function PageHero({ eyebrow, lines, copy, children }) {
  return (
    <section className="relative overflow-hidden bg-ink pb-12 pt-28 sm:pt-36">
      <div className="spotlight absolute inset-0" aria-hidden="true" />
      <div className="bg-grid fade-b absolute inset-0" aria-hidden="true" />
      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        {eyebrow && (
          <motion.span
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="font-mono text-xs font-semibold uppercase tracking-[0.2em] text-brand"
          >
            {eyebrow}
          </motion.span>
        )}
        <h1 className="mt-4 max-w-4xl font-display text-4xl font-extrabold leading-[1.08] tracking-tight text-white sm:text-5xl lg:text-6xl">
          {lines.map((line, i) => (
            <MaskedLine key={i} delay={0.15 + i * 0.12}>
              {line}
            </MaskedLine>
          ))}
        </h1>
        {copy && (
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.6, ease: [0.16, 1, 0.3, 1] }}
            className="mt-6 max-w-2xl text-base leading-relaxed text-mist sm:text-lg"
          >
            {copy}
          </motion.p>
        )}
        {children && (
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.75, ease: [0.16, 1, 0.3, 1] }}
            className="mt-8"
          >
            {children}
          </motion.div>
        )}
      </div>
    </section>
  );
}
